import propertyNormalizer from './property-normalizer';

export default {
    mixins: [propertyNormalizer],
    methods: {
        getPropertyValue(properties, propertyId, defaultValue) {
            return this.normalizeVariationProperties(properties, {
                selection: { [propertyId]: 1 },
                sortByPriority: false,
            })[0]?.value?.values?.value ?? defaultValue;
        },
    },
};
